<template>
    <main>
        <div class="header"><div class="top"></div></div>
        <div class="error">
            <div class="center">
                <div class="middle">
                    <div class="num">404</div>
                    <div class="message">您访问的页面不存在</div>
                    <div class="btn" @click="util.toLink('/')">返回首页</div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import Crumbs from "../../components/m/Crumbs";
    export default {
        name: 'error',
        data() {
            return {
                query:"",
            }
        },
        components:{
            Crumbs
        },
        computed:{
            crumbs() {
                return [
                    {title:'Error'},
                ]
            },
        },
        methods: {

        },
        mounted() {
            this.query = this.$route.query;
            this.util.showBottom(true);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .m-header{
        .top{position: fixed; height:.88rem;overflow: hidden;top:0;left:0;width:100%;z-index: 99;background:#126399 url("~@/assets/image/20.jpg") no-repeat top center;background-size: 100%;}
    }
    .error{margin: 0 auto;min-height:100vh;background:rgba(11,17,49,1) url("~@/assets/image/20.jpg") no-repeat top center;background-size: 100%;text-align: center;display: flex;align-items: center;justify-content: center;
        .center{
            .middle{width: 7.5rem;color: #fff;
                .num{font-size: 2rem;line-height: 2rem;margin-top: .5rem;}
                .message{font-size: .32rem;font-weight: bold;line-height: .8rem;}
                .btn{padding: 0 .5rem;display: inline-block;height:.6rem;line-height: .6rem;margin-bottom:.8rem; text-align: center;font-size: .28rem;color:#fff;background: #3176c8;transition: all .3s ease;cursor: pointer;margin-top: .2rem;}
            }
        }
    }
</style>

